<!--
2023-06-29 YTW 邀请功能优化
-->
<template>
  <div class="main-content">
    <div class="fixWidth" ref="fixWidth" @scroll="handleScroll">
      <div class="headBox" v-if="userInfo">
        <div class="backBox" style="width: 100vw">
          <TopBack :title="$t('lang.inviteFriends.Affiliate')" style="position: relative;z-index: 1;flex-shrink: 0;"/>
        </div>
        <div class="bannerBox">
          <img src="../../assets/images/invite/banner.png" alt="" class="banner">
        </div>
      </div>
      <div v-else class="backBox" style="width: 100vw;position: absolute">
        <TopBack :title="$t('lang.inviteFriends.Affiliate')" style="position: relative;z-index: 1;flex-shrink: 0;"/>
      </div>
      <div class="tabBar" v-if="userInfo" :style="{backgroundImage:'url('+require('../../assets/images/invite/tabCardBg.png')+')'}">
        <div :class="active === 0?'tabItemActive':'tabItem'" @click="setActive(0)">
          <img v-if="active === 0" src="../../assets/images/invite/earnIconActive.png" alt="" class="icon">
          <img v-else src="../../assets/images/invite/earnIcon.png" alt="" class="icon">
          <div class="label">{{$t('lang.invitee.earn')}}</div>
        </div>
        <div :class="active === 1?'tabItemActive':'tabItem'" @click="setActive(1)">
          <img v-if="active === 1" src="../../assets/images/invite/teamDataIconActive.png" alt="" class="icon">
          <img v-else src="../../assets/images/invite/teamDataIcon.png" alt="" class="icon">
          <div class="label">{{$t('lang.invitee.teamData')}}</div>
        </div>
        <div :class="active === 2?'tabItemActive':'tabItem'" @click="setActive(2)">
          <img v-if="active === 2" src="../../assets/images/invite/howToEarnIconActive.png" alt="" class="icon">
          <img v-else src="../../assets/images/invite/howToEarnIcon.png" alt="" class="icon">
          <div class="label">{{$t('lang.invitee.howToEarn')}}</div>
        </div>
      </div>
      <div class="earnBox" v-show="userInfo && active === 0">
        <earnPage :linkUrl="linkUrl" :shareCodeData="shareCode" :pageData="{reardConfig, uncollectReward}" @resetReard="getUncollectReward"/>
      </div>
      <div class="teamDataBox" v-show="userInfo && active === 1">
        <teamDataPage @inviteFriendsToBoostYourBonusPopOpen="inviteFriendsToBoostYourBonusPopShow = true" :pageData="teamMembers" @openInvitePop="openInvitePop" />
      </div>
      <div class="howToEarnBox" v-show="!userInfo || active === 2">
        <howToEarnPage :pageData="{reardConfig, uncollectReward}" />
      </div>
    </div>
    <img src="../../assets/images/invite/inviteNow.png" alt="" class="inviteNow" @click="openInviteNow()">
    <img src="../../assets/images/invite/goTop.png" alt="" class="goTop" @click="goTop()" v-if="goTopBtnShow">
    <div class="inviteFriendsToBoostYourBonusMarsk" v-if="inviteFriendsToBoostYourBonusPopShow">
      <div class="inviteFriendsToBoostYourBonusPop">
        <div class="title">{{$t('lang.invitee.inviteFriendsToBoostYourBonus')}}</div>
        <div class="tableDataBox" :style="{backgroundImage:'url('+require('../../assets/images/invite/teamDataTableCardBg.png')+')'}">
          <div class="head">
            <div class="column" :style="{width: columnWith1 + 'vw'}">{{$t('lang.invitee.teamLevel')}}</div>
            <div class="column" :style="{width: columnWith2 + 'vw'}">{{$t('lang.invitee.teamMember')}}</div>
            <div class="column" :style="{width: columnWith3 + 'vw'}">{{$t('lang.invitee.subDeposit')}}</div>
            <div class="column" :style="{width: columnWith4 + 'vw'}">{{$t('lang.invitee.dCommission')}}</div>
            <div class="column" :style="{width: columnWith5 + 'vw'}">{{$t('lang.invitee.bCommission')}}</div>
          </div>
          <div class="body">
            <div class="row" v-for="(item,index) in LevelConfig" :key="index">
              <div class="column" :style="{width: columnWith1 + 'vw'}">{{item.Level}}</div>
              <div class="column" :style="{width: columnWith2 + 'vw'}">{{item.TeamMembers}}</div>
              <div class="column" :style="{width: columnWith3 + 'vw'}">{{item.SubDepositAmount}}</div>
              <div class="column" :style="{width: columnWith4 + 'vw'}">{{item.DepositRate}}%</div>
              <div class="column" :style="{width: columnWith5 + 'vw'}">{{item.BetRate}}%</div>
            </div>
          </div>
        </div>
        <div class="inviteFriendsToBoostYourBonusTip">
          {{$t('lang.invitee.inviteFriendsToBoostYourBonusTip')}}
        </div>
        <img @click="inviteFriendsToBoostYourBonusPopShow = false" src="../../assets/images/invite/close.png" alt="" class="close">
      </div>
    </div>
    <div class="invitingFriendsMarsk" v-if="invitingFriendsPopShow">
      <div class="earnRsBox" :style="{backgroundImage:'url('+require('../../assets/images/invite/invitingFriendsBg.webp')+')'}">
        <div class="title">{{$t('lang.invitee.EarnMoneyByInvitingFriends')}}</div>
        <div class="invitationLink">{{$t('lang.invitee.invitationLink')}}</div>
        <div class="linkBox">
          <div class="link">{{linkUrl}}</div>
          <div class="copyBtn" @click="copyLinkClick">{{$t('lang.invitee.copy')}}</div>
        </div>
        <div class="shareViaSocials">{{$t('lang.invitee.shareViaSocials')}}</div>
        <div class="sharBox">
          <div class="itemBox" @click="whatsappClick()">
            <img src="../../assets/images/invite/ic_whatsapp.png" alt="" class="icon">
            <div class="label">{{$t('lang.invitee.whatsapp')}}</div>
          </div>
          <div class="itemBox" @click="instagramClick()">
            <img src="../../assets/images/invite/ic_Instagram.png" alt="" class="icon">
            <div class="label">{{$t('lang.invitee.instagram')}}</div>
          </div>
          <div class="itemBox"  @click="telegramClick()">
            <img src="../../assets/images/invite/ic_telegram.png" alt="" class="icon">
            <div class="label">{{$t('lang.invitee.telegram')}}</div>
          </div>
          <div class="itemBox" @click="facebookClick()">
            <img src="../../assets/images/invite/ic_facebook.png" alt="" class="icon">
            <div class="label">{{$t('lang.invitee.facebook')}}</div>
          </div>
        </div>
        <img @click="invitingFriendsPopShow = false" src="../../assets/images/invite/close.png" alt="" class="close">
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import TopBack from '@/components/TopBack/index'
import progressInvite from '@/components/ProgressLine/progressInvite'
import {Toast} from 'mint-ui'
import request from '@/service'
import store from '../../store/store'
import {closePop} from '@/utils'
import inviteUpdatePop from '@/components/inviteUpdatePop'
import earnPage from './earnPage'
import howToEarnPage from './howToEarnPage'
import teamDataPage from './teamDataPage'
export default {
  name: 'Earn',
  computed: {
    store () {
      return store
    },
    inviteUpdatePop: {
      cache: false,
      get () {
        const currentModalIndex = store.state.currentModalIndex
        const modals = store.state.modals
        if (currentModalIndex === 17) {
          return modals[17].showing
        } else {
          return false
        }
      }
    }
  },
  data () {
    return {
      linkUrl: '',
      active: 0,
      fromRoute: '',
      shareCode: '',
      inviteFriendsToBoostYourBonusPopShow: false,
      invitingFriendsPopShow: false,
      goTopBtnShow: false,
      columnWith1: 14,
      columnWith2: 18,
      columnWith3: 18,
      columnWith4: 20,
      columnWith5: 19,
      visitorCode: localStorage.getItem('visitorCode'),
      language: localStorage.getItem('locale'),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      reardConfig: null,
      uncollectReward: null,
      teamMembers: null,
      LevelConfig: []
    }
  },
  components: {
    TopBack,
    progressInvite,
    inviteUpdatePop,
    earnPage,
    howToEarnPage,
    teamDataPage
  },
  watch: {
    '$store.state.locale': function (n, o) {
      this.language = localStorage.getItem('locale')
      if (n === 'EN') {
        this.whiteTitle = 'whiteTitleEN'
        this.desc = 'descEN'
      } else if (n === 'IN') {
        this.whiteTitle = 'whiteTitleIN'
        this.desc = 'descIN'
      }
      if (this.alertTemp !== null) {
        switch (this.alertType) {
          case 1:
            this.alertTitle = this.$t('lang.inviteFriends.congrats')
            this.alertFonts = this.$t('lang.inviteFriends.alert1').replace('{Times}', this.alertTemp.SettingTimes)
            break
          case 2:
            this.alertTitle = this.$t('lang.inviteFriends.success')
            this.alertFonts = this.$t('lang.inviteFriends.alert4').replace('{RewardAmount}', this.alertTemp.RewardAmount)
            break
        }
      }
    }
  },
  created () {
    this.getReardConfig()
    this.getUncollectReward()
    this.getTeamData()
    this.getLevelConfig()
    if (this.userInfo) {
      let modelsFromLocalStorage = JSON.parse(localStorage.getItem('modals'))
      try {
        if (modelsFromLocalStorage && modelsFromLocalStorage[18]) {
          modelsFromLocalStorage[18].popupTimes = 1
          modelsFromLocalStorage[18].updateDateSpan = new Date().getTime()
          localStorage.setItem('modals', JSON.stringify(modelsFromLocalStorage))
        }
      } catch (e) {
      }
    }
  },
  mounted () {},
  beforeDestroy () {
    // sessionStorage.removeItem('inviteePageActive')
  },
  updated () {
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fromRoute = from.name
      vm.initActive()
    })
  },
  methods: {
    ...mapMutations({
      setUserVerifyInfo: 'setUserVerifyInfo'
    }),
    openInviteNow () {
      this.invitingFriendsPopShow = true
      this.saveUserEvent('openInviteNow')
    },
    initActive () {
      if (sessionStorage.getItem('inviteePageActive') && this.fromRoute && (this.fromRoute === 'EarnDetails' || this.fromRoute === 'ShareFiesta' || this.fromRoute === 'cashWheel' || this.fromRoute === 'inviteRules')) {
        this.active = JSON.parse(sessionStorage.getItem('inviteePageActive'))
      } else {
        this.active = 0
      }
      if (this.userInfo) {
        this.fetchAccount()
      }
    },
    getLevelConfig () {
      const url = '/innovation/invite_relation/get/level/config'
      request('get', url).then(res => {
        if (res) {
          this.LevelConfig = res
        }
      })
    },
    telegramClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.saveUserEvent('Telegram')
      this.copyShares()
      let message = encodeURIComponent(this.msgFormat())
      window.open(`https://t.me/share/url?text=` + message + `&url=%20`)
    },
    whatsappClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.saveUserEvent('WhatsApp')
      this.copyShares()
      let message = encodeURIComponent(this.msgFormat())
      window.open(`https://wa.me/?text=${message}`, '_blank')
    },
    facebookClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.saveUserEvent('Facebook')
      this.copyShares()
      window.open(`https://www.facebook.com/sharer.php?u=${encodeURIComponent(this.shareCode)}`, '_blank')
    },
    msgFormatFB () {
      let welcomeMessage = ''
      // Check if shareType already exists in the shareCode
      if (!this.shareCode.includes('shareType=')) {
        // Append the shareType parameter to the shareCode
        if (this.shareCode.includes('?')) {
          this.shareCode += '&shareType=EARN'
        } else {
          this.shareCode += '?shareType=EARN'
        }
      }
      welcomeMessage = `${this.shareCode} 👋Hey bro, check this out! 💰Give you ₹177 + 30 FREE CASH! 🔥Play India's hottest games and win real money!🎰`
      return welcomeMessage
    },
    async instagramClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      const shareData = {
        text: this.msgFormat()
      }
      this.saveUserEvent('Instagram')
      if (window.Android) {
        window.Android.callShareSheet(JSON.stringify(shareData))
      } else {
        if (navigator.share) {
          try {
            await navigator.share(shareData)
          } catch (e) {
          }
        } else {
          this.copyShares()
        }
      }
    },
    msgFormat () {
      let welcomeMessage = this.$t('lang.sportsBetting.shareMsg')
      let index = this.shareCode.indexOf('/Share')
      if (index === -1) {
        index = this.shareCode.toLowerCase().indexOf('/share')
      }

      welcomeMessage = welcomeMessage.replace('{shareUrl}', this.shareCode)

      return welcomeMessage
    },
    copyShares () {
      let message = this.msgFormat()
      let copyBehavior = function (e) {
        e.clipboardData.setData('text/plain', message)
        e.preventDefault() // 阻止默认行为
      }
      document.addEventListener('copy', copyBehavior)
      document.execCommand('copy')
    },
    copyLinkClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.copyShares()
      this.saveUserEvent('Link2')
      Toast(this.$t('lang.inviteFriends.success'))
    },
    getTeamData () {
      const url = '/innovation/invite_relation/get/team/data'
      const data = {
        UserId: this.userInfo ? this.userInfo.UserId : ''
      }
      request('post', url, data).then(res => {
        if (res) {
          this.teamMembers = res
        }
      })
    },
    // 查询返利比例， 邀请排行榜状态， 裂变状态， 邀请是否封禁
    getReardConfig () {
      const url = '/innovation/invite_relation/get/reward/config'
      const data = {
        UserId: this.userInfo ? this.userInfo.UserId : ''
      }
      request('post', url, data).then(res => {
        if (res) {
          this.reardConfig = res
        }
      })
    },
    // 查询用户待领取奖励
    getUncollectReward () {
      const url = '/innovation/invite_relation/get/uncollect/reward'
      const data = {
        UserId: this.userInfo ? this.userInfo.UserId : ''
      }
      request('post', url, data).then(res => {
        if (res) {
          this.uncollectReward = res
        }
      })
    },
    handleScroll () {
      // 获取滚动容器
      const container = this.$refs.fixWidth
      if (!container) return

      // 更新滚动位置
      this.scrollTop = container.scrollTop

      // 显示/隐藏返回顶部按钮（当滚动超过300px时显示）
      this.goTopBtnShow = this.scrollTop > 300

      // 计算滚动进度
      const scrollHeight = container.scrollHeight - container.clientHeight
      this.scrollProgress = scrollHeight > 0 ? (this.scrollTop / scrollHeight) * 100 : 0
    },
    goTop () {
      const container = this.$refs.fixWidth
      if (!container) return

      // 平滑滚动动画
      const animate = () => {
        if (container.scrollTop > 0) {
          container.scrollTop -= Math.max(10, container.scrollTop / 8)
          requestAnimationFrame(animate)
        }
      }
      animate()
    },
    // 缓动函数：先加速后减速
    easeInOutCubic (t) {
      return t < 0.5
        ? 4 * t * t * t
        : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
    },
    openInvitePop () {
      this.invitingFriendsPopShow = true
    },
    setActive (active) {
      this.active = active
      sessionStorage.setItem('inviteePageActive', this.active)
    },
    closeInviteUpdatePop () {
      closePop(17)
    },
    imgShareClick () {
      this.saveUserEvent('ShareNow')
      this.$router.push('/Invite')
    },
    closePanel () {
      this.showPanel = false
    },
    getViralityEnter () {
      let data = {
        UserId: this.userInfo ? this.userInfo.UserId : '',
        visitorCode: this.visitorCode
      }
      request('post', 'innovation/virality/status', data, false).then(res => {
        this.cashWheelIsStart = res
      })
    },
    getCashWeelReddot () {
      request('post', 'innovation/virality/get/collect/status', {UserId: this.userInfo ? this.userInfo.UserId : '', visitorCode: this.visitorCode}).then(res => {
        if (res) {
          this.cashWheelRedDot = res.IsHaveUncollect
        }
      })
    },
    // msgFormat () {
    //   let welcomeMessage = this.$t('lang.inviteFriends.inviteMsg')
    //   let index = this.shareCode.indexOf('/Share')
    //   if (index === -1) {
    //     index = this.shareCode.toLowerCase().indexOf('/share')
    //   }
    //   if (index !== -1) {
    //     const pre = this.shareCode.substring(0, index)
    //     this.shareCode = this.shareCode.replace(pre, 'https://' + location.host)
    //   }
    //   welcomeMessage = welcomeMessage.replace('{shareURL}', this.shareCode)
    //   welcomeMessage = welcomeMessage.replace('{amount1}', this.amount1)
    //   welcomeMessage = welcomeMessage.replace('{amount2}', this.amount2)
    //   welcomeMessage = welcomeMessage.replace('{amount3}', this.amount3)
    //   return welcomeMessage
    // },
    initLinkUrl () {
      this.linkUrl = this.shareCode
    },
    copyNum (index) {
      let shares = this.phoneNum
      if (index === 1) {
        shares = this.telegramAccount
      }
      let copyBehavior = function (e) {
        e.clipboardData.setData('text/plain', shares)
        e.preventDefault() // 阻止默认行为
      }
      document.addEventListener('copy', copyBehavior)
      document.execCommand('copy')
      Toast(this.$t('lang.inviteFriends.success'))
    },
    addNum (index) {
      if (index === 0) {
        window.open('https://t.me/' + this.telegramAccount, '_blank')
      } else {
        window.open('http://wa.me/' + this.phoneNum, '_blank')
      }
    },
    fetchAccount () {
      let that = this
      const url = '/innovation/account/getuseraccount'
      const data = {
        UserId: this.userInfo.UserId
      }
      request('post', url, data).then(res => {
        that.shareCode = res.InviteLink
        that.fetchLocalAmount()
        that.initLinkUrl()
      }).catch(err => {
        console.log(err)
      })
    },
    fetchLocalAmount () {
      const url = '/innovation/home/get-system-settings'
      let cid = localStorage.getItem('cid') // （注：从localstorage取出cid）
      const data = {IsApp: 1, CampaignId: cid, UserId: this.userInfo ? this.userInfo.UserId : ''}
      request('post', url, data).then(res => {
        this.amount1 = res.SevenDayReward
        this.amount2 = res.InviteeReward
        this.amount3 = res.FirstDepositMaxReward
        this.$store.commit('setInviteeObj',
          {
            sevenDayReward: res.SevenDayReward,
            inviteeMaxReward: res.DefaultCampaignIdFirstDepositMaxReward,
            InviteeReward: res.InviteeReward
          })
        this.$store.commit('setSharingStarIcon', res.InviteRankActivitySwitch)
      }).catch(err => {
        console.log(err)
      })
    },
    fetchInviteData () {
      const url = '/innovation/invite_relation/version_sub/get_invite_data'
      const data = {
        UserId: this.userInfo.UserId
      }
      request('post', url, data, true).then(res => {
        this.hasGotReward = res.CompletedRewardBetAmount > 0
        this.btnStatus = res.ButtonStatus
        this.subBtnStatus = res.SubButtonStatus
        this.subShow = res.SubInviteesActivitySwith
        this.lockAmount = res.NeedMonthlyTaskValue
        // this.subShow = false
        this.currentDegrees = res.InviteesBetAmount / 100000
        this.subCurrentDegrees = res.SubInviteesBetAmount / 100000
        this.gifts = res.RewardFormulaList
        this.subGifts = res.SubRewardFormulaList
        this.RewardsFonts[0].amount = res.TotalRewards
        this.RewardsFonts[1].amount = res.RewardsAvailable
        this.RewardsFonts[2].amount = res.TotalInvited
        this.phoneNum = res.PhoneNumber
        this.telegramAccount = res.TelegramAccount
      }).catch(err => {
        console.log(err)
      })
    },
    receiveInviteReward () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      if (this.btnStatus !== 1) {
        return
      }
      const url = '/innovation/invite_relation/version_sub/receive_bet_reward'
      const data = {
        UserId: this.userInfo ? this.userInfo.UserId : ''
      }
      request('post', url, data, true).then(res => {
        this.subShow = res.SubInviteesActivitySwith
        this.tipShow = res.ContactAdministrator && res.RemainingTimes === 0
        this.hasGotReward = (res.RewardAmount + res.ManualRewardAmount) > 0 || res.ContactAdministrator
        if (res.RewardAmount > 0) {
          this.alertType = 2
          this.alertMsg(res.RewardAmount)
          this.fetchBalance()
        } else {
          this.alertType = 1
          this.alertMsg(res.RewardAmount, res.SettingTimes)
        }
        this.fetchInviteData()
      }).catch(err => {
        console.log(err)
      })
    },
    receiveSubInviteReward () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      if (this.subBtnStatus !== 1) {
        return
      }
      const url = '/innovation/invite_relation/version_sub/receive_sub_bet_reward'
      const data = {
        UserId: this.userInfo.UserId
      }
      request('post', url, data, true).then(res => {
        this.subShow = res.SubInviteesActivitySwith
        this.tipShow = res.ContactAdministrator
        this.alertType = 1
        if (res.RewardAmount > 0) {
          this.alertType = 2
          // 单纯领取成功
          this.alertSubMsg(1)
          this.fetchBalance()
        } else if (res.CollectedDoneToday && res.RewardAmount === 0) {
          this.alertType = 1
          // 明天再来
          this.alertSubMsg(2)
        }
        this.fetchInviteData()
      }).catch(err => {
        console.log(err)
      })
    },
    receiveDetails () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      if (this.subShow) {
        localStorage.setItem('subShow', 'show')
      } else {
        localStorage.setItem('subShow', 'hide')
      }
      this.$router.push('/EarnDetails')
    },
    alertMsg (RewardAmount, SettingTimes) {
      if (!this.hasGotReward) {
        return
      }
      this.alertTemp = {RewardAmount: RewardAmount, SettingTimes: SettingTimes}
      switch (this.alertType) {
        case 1:
          this.alertTitle = this.$t('lang.inviteFriends.congrats')
          this.alertFonts = this.$t('lang.inviteFriends.alert1').replace('{Times}', SettingTimes)
          break
        case 2:
          this.alertTitle = this.$t('lang.inviteFriends.success')
          this.alertFonts = this.$t('lang.inviteFriends.alert4').replace('{RewardAmount}', RewardAmount)
          break
      }
      this.isModalShowing = true
    },
    alertSubMsg (type) {
      this.alertTemp = null
      switch (type) {
        case 1:
          this.alertTitle = this.$t('lang.inviteFriends.success')
          this.alertFonts = this.$t('lang.inviteFriends.alert2')
          break
        case 2:
          this.alertTitle = this.$t('lang.inviteFriends.sorry')
          this.alertFonts = this.$t('lang.inviteFriends.alert5')
          break
      }
      this.isModalShowing = true
    },
    getStaticData () {
      const url = '/innovation/invite_relation/not_login/get_invite_data'
      request('post', url, {}).then(r => {
        this.btnStatus = r.ButtonStatus
        this.subBtnStatus = r.SubButtonStatus
        this.subShow = r.SubInviteesActivitySwith
        this.lockAmount = r.NeedMonthlyTaskValue
        this.currentDegrees = r.InviteesBetAmount / 100000
        this.subCurrentDegrees = r.SubInviteesBetAmount / 100000
        this.gifts = r.RewardFormulaList
        this.subGifts = r.SubRewardFormulaList
        this.RewardsFonts[0].amount = r.TotalRewards
        this.RewardsFonts[1].amount = r.RewardsAvailable
        this.RewardsFonts[2].amount = r.TotalInvited
        this.phoneNum = r.PhoneNumber
        this.telegramAccount = r.TelegramAccount
      }).catch(err => {
        console.log(err)
      })
    },
    // 埋点
    saveUserEvent (val) {
      const url = '/innovation/account/save/user/event'
      const data = {EventNameEN: val, UserUniqueId: this.userInfo.UserId}
      request('post', url, data).then(res => {
      }).catch(err => {
        console.log(err)
      })
    },
    goto (label) {
      this.$router.push('/' + label)
    }
  }
}
</script>
<style lang="less">
#app {
  #viewContainer {
    overflow: hidden;
  }
}
</style>
<style lang="less" scoped>
//::v-deep #app > #viewContainer { /* 增加父级选择器提升权重 */
//  overflow: hidden !important;
//}
.main-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #161616;
  padding: 56px 0 0 0;
  overflow: hidden;

  .fixWidth {
    position: fixed;
    top: 56px;
    left: 0;
    width: 100vw;
    height: calc(100dvh);
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 126px;
    .headBox{
      width: 100vw;
      height: 54.833vw;
      .bannerBox{
        width: 100vw;
        height: 54.833vw;
        //position: absolute;
        //top: 0vw;
        .banner{
          position: absolute;
          width: 100vw;
          height: 54.833vw;
          left: 0;
          top: 0;
        }
      }
    }
    .tabBar{
      width: 90vw;
      height: 11.611vw;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      //border: 1px solid red;
      position: absolute;
      top: 54.5vw;
      border-radius: 2.2vw;
      display: flex;
      align-items: center;
      justify-content: space-between;
      overflow: hidden;
      z-index: 10;
      .tabItem{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        flex: 1;
        gap: 1.5vw;
        .icon{
          height: 4.277vw;
          width: 4.277vw;
        }
        .label{
          color: #505B5D;
          font-size: 3.444vw;
          position: relative;
          top: 0.5vw;
        }
      }
      .tabItemActive{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        background: #2C3641;
        flex: 1;
        gap: 1.5vw;
        .icon{
          height: 4.277vw;
          width: 4.277vw;
        }
        .label{
          color: #fff;
          font-size: 3.444vw;
          position: relative;
          top: 0.5vw;
        }
      }
    }
  }
}

.fixWidth::-webkit-scrollbar {
  display: none
}
.goTop{
  position: fixed;
  right: 4.8vw;
  top: 147vw;
  height: 13.105vw;
  width: 12.45vw;
  z-index: 10;
}
.inviteNow{
  position: fixed;
  right: 4vw;
  top: 130vw;
  height: 14.105vw;
  width: 13.45vw;
  z-index: 10;
}
.invitingFriendsMarsk{
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  .earnRsBox{
    background-size: 100% 100%;
    height: 75vw;
    width: 95vw;
    margin-top: 5vw;
    position: relative;
    animation: openBox 0.2s ease-in-out;
    .title{
      font-family: 'Inter';
      font-style: normal;
      font-weight: 700;
      font-size: 4.2vw;
      text-align: center;
      text-transform: capitalize;
      background: linear-gradient(90deg, #FFFFFF 0%, #E9FFA2 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
      position: absolute;
      top: 5vw;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .invitationLink{
      font-size: 3.611vw;
      color: #fff;
      position: absolute;
      top: 20vw;
      left: 6vw;
    }
    .linkBox{
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      top: 29vw;
      left: 7vw;
      width: 78vw;
      .link{
        font-size: 3.2vw;
        margin-left: 1vw;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        line-height: 121.99%;
        text-transform: capitalize;
        color: #F0F0F0;
        opacity: 0.52;
        width: 65vw;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .copyBtn{
        color: #007BFF;
        font-size: 3.2vw;
        border-bottom: 1px solid;
        padding-bottom: 0.2vw;
        //margin-right: 1vw;
      }
    }
    .shareViaSocials{
      font-size: 3.611vw;
      color: #fff;
      position: absolute;
      top: 38vw;
      left: 6vw;
    }
    .sharBox{
      display: flex;
      align-items: center;
      justify-content: space-around;
      position: relative;
      top: 46vw;
      .itemBox{
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2vw;
        .icon{
          height: 20vw;
          width: 20vw;
        }
        .label{
          font-size: 2.777vw;
          color: #fff;
          font-weight: 700;
        }
      }
    }
    .close{
      position: absolute;
      height: 3.9vw;
      width: 3.9vw;
      bottom: -8vw;
      left: 45vw;
    }
  }
}
.inviteFriendsToBoostYourBonusMarsk{
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  .inviteFriendsToBoostYourBonusPop{
    background-color: rgb(27,27,28);
    height: 135vw;
    width: 95vw;
    border-radius: 3vw;
    position: relative;
    animation: openBox 0.2s ease-in-out;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 3vw;
    .title{
      color: #FFFFFF;
      font-size: 4.722vw;
      margin-top: 5vw;
    }
    .tableDataBox{
      width: 100%;
      height: 66vw;
      background-size: 100% 100%;
      margin-top: 4vw;
      display: flex;
      flex-direction: column;
      font-size: 3.1vw;
      font-weight: 700;
      padding: 0 1vw;
      .head{
        width: 100%;
        height: 11vw;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .column{
          text-align: center;
        }
      }
      .body{
        width: 100%;
        flex: 1;
        color: #fff;
        display: flex;
        flex-direction: column;
        gap: 4vw;
        padding: 3vw 0;
        font-weight: 500;
        overflow-x: hidden;
        overflow-y: auto;
        .row{
          display: flex;
          align-items: center;
          justify-content: space-between;
          .column{
            text-align: center;
          }
        }
      }
    }
    .inviteFriendsToBoostYourBonusTip{
      color: #787878;
      font-size: 4.166vw;
      margin-top: 6vw;
    }
    .close{
      position: absolute;
      height: 3.9vw;
      width: 3.9vw;
      bottom: -8vw;
      left: 45vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Invitee/index.vue